<template>
  <div class="addOwner">
    <md-popup v-model="show" :mask-closable="false">
      <md-popup-title-bar :title="subData.id?'编辑货主':'新增货主'" :only-close="true" @cancel="cancelPop()"></md-popup-title-bar>
      <div class="pop_content">
          <md-field>
            <md-input-item title="货主名称" clearable type="text" v-model="subData.name" placeholder="请输入货主名称"></md-input-item>
            <md-input-item title="手机号" clearable type="phone" v-model="subData.mobile" placeholder="请输入手机号"></md-input-item>
            <md-input-item title="货主编号" clearable type="digit" :maxlength='4' v-model="subData.supplier_sn" placeholder="请输入货主编号"></md-input-item>
          </md-field>
          <div class="pop_btns">
            <md-button type="warning" plain size="small" inline @click="cancelPop()">取消</md-button>
            <md-button type="primary" size="small" inline @click="submitData()">保存</md-button>
          </div>
      </div>
    </md-popup>

  </div>
</template>

<script>
import { owner_update ,owner_sn} from "@/api/work/owner";
import { isEmpty, isMobile  } from "@/utils/validate";
export default {
  name: 'addOwner',
  data(){
    return {
      show:false,
      loading:true,
      subData:{
        id:'',
        name:'',
        mobile:'',
        supplier_sn:''
      },
    }
  },
  created(){
    
  },
  mounted(){

  },
  methods:{
    // 显示弹窗
    showPop(item){
      if(item){
        this.subData = {
          id:item.id,
          name:item.name,
          mobile:item.mobile,
          supplier_sn:item.supplier_sn
        }
      }else{
        this.getSn()
      }
      this.show = true
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 取消弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        id:'',
        name:'',
        mobile:'',
        supplier_sn:''
      }
    },
    // 提交数据
    submitData(type){
      if(!this.loading){ return false }
      if(!this.subData.name){ this.$toast.info("请输入货主姓名！"); return false }
      if(!isMobile(this.subData.mobile)){ this.$toast.info("请输入正确的手机号码！"); return false }
      if(!this.subData.supplier_sn){ this.$toast.info("请输入货主编号！"); return false }
      this.loading = false
      owner_update(this.subData).then(res=>{
        this.loading = true
        this.$toast.succeed(res.message)
        this.finishPop()
      }).catch(err=>{
        this.loading = true
      })
    },

    // 获取货主编号
    getSn(){
      owner_sn().then(res=>{
        if(res.code == 200 ){
          this.subData.supplier_sn = res.data.num
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.addOwner{
  position: relative;
  // 添加买家模块
  .pop_content {
    width: 5rem;
    // height: 6rem;
    background-color: #fff;
    border-radius:0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding:0.1rem 0.2rem 0;
    position: relative;
    .pop_btns{
      padding: 0.35rem 1rem 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>